import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    & > :nth-of-type(-n + ",
        ") {\n      visibility: hidden;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { InteractiveText, Ui } from "@silvertours/front-shared";
import { darken } from "polished";
var Nav = /*#__PURE__*/ styled("nav", {
    target: "eou6uu90"
})("display:", function(param) {
    var $mode = param.$mode;
    return $mode === "desktop" ? "none" : "flex";
}, ";justify-content:center;overflow:", function(param) {
    var $mode = param.$mode;
    return $mode === "desktop" ? "hidden" : "initial";
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:", function(param) {
    var $mode = param.$mode;
    return $mode === "mobile" ? "none" : "block";
}, ";}");
var LinkList = /*#__PURE__*/ styled("ul", {
    target: "eou6uu91"
})("max-width:400px;margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";margin-left:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";display:flex;flex-direction:column;flex:1;justify-content:flex-end;", function(param) {
    var hideChildren = param.hideChildren;
    return css(_templateObject(), hideChildren);
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{margin-bottom:0;margin-left:0;max-width:none;flex-direction:row;padding-top:0;}");
var LinkListItem = /*#__PURE__*/ styled("li", {
    target: "eou6uu92"
})("display:flex;gap:0.5rem;align-items:center;position:relative;margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";white-space:nowrap;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{height:", function(param) {
    var container = param.container;
    return container === "navbar" && "50px";
}, ";margin-bottom:", function(param) {
    var container = param.container;
    return container === "navbar" ? "25px" : 0;
}, ";align-items:", function(param) {
    var container = param.container;
    return container === "navbar" && "end";
}, ";}");
var LinkText = function(param) {
    var theme = param.theme;
    return /*#__PURE__*/ css("color:", theme.color.primary, ";", theme.mq("lg"), "{color:", theme.color.natural30, ";}&:hover{color:", theme.color.primary100, ";}&:active{color:", darken(0.1, theme.color.primary100 || "#000"), ";}");
};
var MaskedLink = /*#__PURE__*/ styled(Ui.MaskedLink, {
    target: "eou6uu93"
})(LinkText, ";");
var Anchor = /*#__PURE__*/ styled("a", {
    target: "eou6uu94"
})(LinkText, "  text-decoration:none;");
var StyledText = /*#__PURE__*/ styled(InteractiveText, {
    target: "eou6uu95"
})(function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{padding-left:", function(param) {
    var theme = param.theme, withPadding = param.withPadding;
    return withPadding ? theme.spacing[50] : 0;
}, ";margin-top:0;list-style-type:none;}", function(param) {
    var theme = param.theme;
    return theme.mq("xl");
}, "{padding-left:", function(param) {
    var theme = param.theme, withPadding = param.withPadding;
    return withPadding ? theme.spacing[60] : 0;
}, ";}");
var StyledBadge = /*#__PURE__*/ styled(Ui.Badge, {
    target: "eou6uu96"
})("font-size:0.75rem;/* @TODO:Move this to Ui.Badge once the legacy header has been removed. */\n\n  ", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{position:", function(param) {
    var container = param.container;
    return container === "navbar" && "absolute";
}, ";top:", function(param) {
    var container = param.container;
    return container === "navbar" && "0.5rem";
}, ";right:", function(param) {
    var container = param.container;
    return container === "navbar" && "-0.75rem";
}, ";}");
export { LinkList, LinkListItem, Anchor, MaskedLink, Nav, StyledText, StyledBadge };
